import * as React from 'react';
import { Tab, Tabs } from '@mui/material';
import { useTranslation } from "react-i18next";
import { ScheduleEntry } from '../../domain/ScheduleEntry';
import { ScheduleWeek } from '../../domain/ScheduleWeek';
import ScheduleFieldServiceTab from './ScheduleFieldServiceTab';
import SchedulePageInfoBox from './SchedulePageInfoBox';
import { ScheduleView } from './ScheduleContent';

interface Props {
    week?: ScheduleWeek;
    entries: ScheduleEntry[];
    editable?: boolean;
    view?: ScheduleView;
    onEntryUpdate?: (entry: ScheduleEntry) => void;
    onEntryEdit?: (entry: ScheduleEntry) => void;
    onPublisherScheduleHistory?: (entry: ScheduleEntry) => void;
    onEntryAssignmentHistory?: (entry: ScheduleEntry) => void;
    onEntrySendNotification?: (entry: ScheduleEntry) => void;
    onEntryAutoArrange?: (entry: ScheduleEntry) => void;
}

const ScheduleSkippedWeekTabs = (props: Props) => {
    const { t } = useTranslation();
    const [tab, setTab] = React.useState(0);

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
    };

    return (
        <>
            <Tabs value={tab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
                <Tab label={t("week")} />
                <Tab label={t("field_service_meetings")} />
            </Tabs>
            <div role="tabpanel" hidden={tab !== 0}>
                <SchedulePageInfoBox text={props.week && props.week.notes} />
            </div>
            <div role="tabpanel" hidden={tab !== 1}>
                <ScheduleFieldServiceTab
                    week={props.week!}
                    entries={props.entries.filter(entry => entry.type === "field-service")}
                    editable={props.editable}
                    view={props.view}
                    onEntryUpdate={props.onEntryUpdate}
                    onEntryEdit={props.onEntryEdit}
                    onPublisherScheduleHistory={props.onPublisherScheduleHistory}
                    onEntryAssignmentHistory={props.onEntryAssignmentHistory}
                    onEntrySendNotification={props.onEntrySendNotification}
                    onEntryAutoArrange={props.onEntryAutoArrange}
                />
            </div>
        </>
    );
};

export default ScheduleSkippedWeekTabs;